module.exports = __webpack_public_path__ + "static/media/tomatoes_hero.ddc3fbcd.jpg";